export const DEHUMIDIFIER_IMAGE = "/products/electriq-dehumidifier-200.webp"

export const PRODUCT_CATALOG = [
    { type: "jetwash", sku: "1", slug: "karcher-k4", name: "Kärcher K4", description: "Home and garden cleaning", image: "/products/karcher-k4.jpg" },
    { type: "jetwash", sku: "2", slug: "karcher-xpert-oneten", name: "Kärcher Xpert OneTen 110V", description: "Professional and trade cleaning", image: "/products/karcher-xpert-oneten.jpg" },
    { type: "dehumidifier", sku: "ecd30", slug: "electriq-ecd30", name: "ElectriQ 30L dehumidifier", description: "30L dehumidifier hire", image: DEHUMIDIFIER_IMAGE },
    { type: "dehumidifier", sku: "ecd50", slug: "electriq-ecd50", name: "ElectriQ 50L dehumidifier", description: "50L dehumidifier hire", image: DEHUMIDIFIER_IMAGE },
    { type: "dehumidifier", sku: "ecd70", slug: "electriq-ecd70", name: "ElectriQ 70L dehumidifier", description: "70L dehumidifier hire", image: DEHUMIDIFIER_IMAGE },
    { type: "portable-ac", sku: "7000", slug: "homcom-7000-btu", name: "HOMCOM 7,000 BTU Portable AC", description: "Bedrooms, small offices and smaller classrooms", image: "/products/homcom-portable-ac.jpg" },
    { type: "portable-ac", sku: "10000", slug: "homcom-10000-btu", name: "HOMCOM 10,000 BTU Portable AC", description: "Living rooms, larger classrooms and offices", image: "/products/homcom-portable-ac.jpg" },
] as const

export function productMeta(slug: string) { return PRODUCT_CATALOG.find((item) => item.slug === slug) ?? PRODUCT_CATALOG[0] }

export function productSlugFromSearch(search: string) {
    const params = new URLSearchParams(search)
    const type = params.get("type")
    const sku = params.get("sku")?.toLowerCase() ?? null
    if (type !== null || sku !== null) {
        return PRODUCT_CATALOG.find((item) => item.type === type && item.sku === sku)?.slug ?? "__invalid_product__"
    }
    return params.get("product") ?? ""
}

export function communicateProductInUrl(slug: string) {
    if (typeof window === "undefined") return
    const selected = PRODUCT_CATALOG.find((item) => item.slug === slug)
    if (!selected) return
    const url = new URL(window.location.href)
    url.searchParams.set("type", selected.type)
    url.searchParams.set("sku", selected.sku)
    url.searchParams.delete("product")
    const query = url.searchParams.toString()
    window.history.replaceState(window.history.state, "", `${url.pathname}${query ? `?${query}` : ""}${url.hash}`)
}
